import moment from 'moment-timezone'

/**
 * Converts a DD/MM/YYYY string to an ISO YYYY-MM-DD string.
 * Returns '' if the input is invalid or incomplete.
 */
export function parseBRToISO(br: string): string {
  if (!br || br.includes('_')) return ''
  const m = moment(br, 'DD/MM/YYYY', true)
  if (!m.isValid()) return ''
  return m.format('YYYY-MM-DD')
}
